import React from 'react'
import AdminFAQList from '../../components/AdminSideComponents/DashBoardFaq.jsx/AdminFAQList'

const Faq = () => {
  return (
    <div className='bg-[#EEF3F7] p-6'>
        <AdminFAQList/>
    </div>
  )
}

export default Faq